<template>
    <header class="header">
      <captive-forms-modal />      
    </header>
  </template>
     
  <script>
  import CaptiveFormsModal from "@components/modules/captive-forms/modal/CaptiveFormsModal.vue";
  
  export default {
    components: {
      CaptiveFormsModal
    },
  
    computed: {},
  
    methods: {      
    }
  };
  </script>
    
  <style lang="scss" scoped>
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  </style>
    